import React, { useState } from 'react'
import { RiMenu5Fill } from "react-icons/ri";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { set_sidebar } from '../redux/slices/uiSlice';
import { LANGUAGE_OPTIONS, ROLE_AGENCY, ROLES } from '../constants';
import LanguageSelect from '../components/Filter/LanguageSelect';
import { set_language } from '../redux/slices/languageSlice';
import { customStringify, error_alert, removeToken, setAppLanguage } from '../utils';
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io';
import { logout } from '../redux/slices/userSlice';
import axios from 'axios';
import { network_tl } from '../translations';
import { FormattedMessage, useIntl } from 'react-intl';
import ProfileListing from '../components/ProfileListing';
import HeaderInfluencerProfile from '../components/ProfileListing/HeaderInfluencerProfile';
import Notifications from '../components/Notifications';
import { Tooltip } from 'react-tooltip';

const Page = ({ title, breadcrumbs = [], children, prevPage, prevRoute, noSidebar, description }) => {
    const { sidebar } = useSelector(state => state.ui);
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const user = useSelector(state => state.user);
    const active_profile = useSelector(state => state.influencer_profile.active);
    const lang = useSelector(state => state.language);
    const intl = useIntl();
    const selectedLang = lang ? LANGUAGE_OPTIONS.find(item => item.value.code === lang) : null;
    const { data } = useSelector(state => state.influencer_profile);
    const navigate = useNavigate();


    const handleLanguageChange = (value) => {
        dispatch(set_language(value.value.code))
        setAppLanguage(value.value.code)
    };


    const toggleMenu = () => {
        setOpen(!open);
    };

    const handleLogout = async () => {
        try {
            dispatch(logout());
            removeToken();
        } catch (e) {
            if (axios.isCancel(e)) {
            }
            else if (e.response) {
                error_alert(customStringify(e.response.data.description));
            } else {
                error_alert(network_tl(intl));
            }
        }
    }


    return (
        <div className={`${sidebar && !noSidebar ? "lg:pl-[230px]" : "pl-0"} bg-base-bg transition-all flex flex-col min-h-full `}>
            {/* header */}
            <div className={`bg-content-bg border-2 border-l-0 flex-shrink-0 z-[100] transition-all  ${noSidebar ? "h-[75px]" : "h-[90px]"}  border-base`}>
                <div className='h-full container flex items-center justify-between'>
                    {
                        !sidebar &&
                        <button
                            onClick={() => {
                                dispatch(set_sidebar(true))
                            }}
                            type="button"
                            className='mr-5 h-[40px] w-[40px] min-w-[40px] rounded-full transition-all text-t-light hover:bg-primary hover:text-white flex items-center justify-center'
                        >
                            <RiMenu5Fill className=' text-xl' />
                        </button>
                    }

                    {
                        prevPage &&
                        <button
                            onClick={() => {
                                if (prevRoute) {
                                    navigate(prevRoute);
                                } else {
                                    navigate(-1);
                                }
                            }}

                            type="button"
                            className=' h-[40px] w-[40px] rounded-full transition-all text-t-light hover:bg-primary hover:text-white flex items-center justify-center'
                        >
                            <IoIosArrowBack className=' text-xl' />
                        </button>

                    }


                    <div className={`flex-grow flex flex-col justify-center items-start gap-y-1`}>
                        <h1 className='px-1 text-md leading-4 sm:leading-normal sm:text-xl text-primary font-semibold'>
                            {title}
                        </h1>
                        {
                            description &&
                            <p data-tooltip-id="my-tooltip" data-tooltip-content={`${description}`} className='px-1 text-xs text-t-light line-clamp-1'>{description}</p>
                        }

                        <Tooltip
                            id="my-tooltip"
                            place="bottom"
                            className="custom-tooltip"
                            style={{
                                maxWidth: '300px',
                                fontSize: '12px',
                                borderRadius: '12px',
                                overflowWrap: 'anywhere'
                            }}
                        />

                        {/* <div className='hidden md:flex items-center'>
                            {
                                breadcrumbs.map((item, index) => (
                                    index === breadcrumbs.length - 1 ?
                                        <p key={index} className='text-xs font-bold text-primary py-1 px-2 rounded-full bg-primary/20'>
                                            {item.title}
                                        </p>
                                        :
                                        <div className='flex items-center' key={index} >
                                            <Link key={index} to={item.link} className='text-xs  text-t-light hover:text-primary hover:bg-primary/20 py-1 px-2 rounded-full'>
                                                {item.title}
                                            </Link>
                                            <p className='text-xs mx-2 text-t-light'>
                                                |
                                            </p>
                                        </div>
                                ))
                            }

                        </div> */}
                    </div>

                    <div className=' block sm:flex items-center pr-10'>
                        <div className='flex items-center justify-center gap-3'>
                            {/* <div className='w-[125px]'>
                                <LanguageSelect
                                    options={LANGUAGE_OPTIONS}
                                    state={selectedLang}
                                    setState={handleLanguageChange}
                                    disableClearable={true}
                                    disableSearch={true}
                                />
                            </div> */}
                            {/* USER */}
                            {/* <div className='relative'>
                                <div className='flex items-center gap-x-2 cursor-pointer' onClick={toggleMenu}>
                                    <img src={user.avatar ? user.avatar : "/images/avatar.png"} className='w-14 h-14 rounded-full select-none' alt="User Avatar" />
                                    <IoIosArrowDown className={`flex-shrink-0 text-t-light text-xl transition-transform duration-200 ${open ? "rotate-180" : "rotate-0"}`} />
                                </div>

                                {open && (
                                    <div className='absolute -right-2 mt-2 w-48 bg-white shadow-lg rounded-lg'>
                                       
                                        <div className='p-2'>
                                            <div onClick={handleLogout} className='py-2 px-4 select-none text-t-light hover:bg-primary hover:text-white rounded cursor-pointer'><FormattedMessage id="logout" defaultMessage="Logout" /></div>
                                        </div>
                                    </div>
                                )}
                            </div> */}
                            {/* USER */}
                            {
                                user.role === ROLE_AGENCY.value ? (
                                    active_profile ?
                                        <HeaderInfluencerProfile active_profile={active_profile} />
                                        : data.length > 0 ?
                                            <ProfileListing />
                                            :
                                            <div className='hidden sm:flex gap-x-3 items-center'>
                                                <div
                                                    className={`flex items-center justify-center w-12 h-12 min-w-12 min-h-12  rounded-xl bg-base-bg bg-cover bg-center bg-no-repeat`}
                                                    style={{
                                                        backgroundImage: `url(${user?.picture})`
                                                    }}
                                                >
                                                    {
                                                        !user.picture &&
                                                        <p className='text-sm font-semibold text-primary uppercase'>
                                                            {user.name ? user.name[0] : ""}{user.sur_name ? user.sur_name[0] : ""}
                                                        </p>
                                                    }
                                                </div>
                                                {
                                                    !noSidebar &&
                                                    <div className='flex flex-col'>
                                                        <p className='text-sm text-black'>
                                                            {`${user.name} ${user.sur_name}`.length > 30
                                                                ? `${user.name} ${user.sur_name}`.substring(0, 30) + '...'
                                                                : `${user.name} ${user.sur_name}`
                                                            }
                                                        </p>
                                                        <p className='text-xs text-t-light'>{user.email}</p>
                                                    </div>
                                                }
                                            </div>
                                ) :
                                    <div className='hidden sm:flex gap-x-3 items-center'>
                                        <div
                                            className={`flex items-center justify-center w-12 h-12 min-w-12 min-h-12  rounded-xl bg-base-bg bg-cover bg-center bg-no-repeat`}
                                            style={{
                                                backgroundImage: `url(${user?.picture})`
                                            }}
                                        >
                                            {
                                                !user.picture &&
                                                <p className='text-sm font-semibold text-primary uppercase'>
                                                    {user.name ? user.name[0] : ""}{user.sur_name ? user.sur_name[0] : ""}
                                                </p>
                                            }
                                        </div>
                                        <div className='flex flex-col'>
                                            <p className='text-sm text-black'>
                                                {`${user.name} ${user.sur_name}`.length > 30
                                                    ? `${user.name} ${user.sur_name}`.substring(0, 30) + '...'
                                                    : `${user.name} ${user.sur_name}`
                                                }
                                            </p>
                                            <p className='text-xs text-t-light'>{user.email}</p>
                                        </div>
                                    </div>
                            }
                            <Notifications />

                        </div>
                    </div>
                </div>
            </div>
            {/* header */}

            {/* PAGE CHILDREN TO GO HERE */}
            <div className='flex-grow mt-3'>
                {
                    children
                }
            </div>
            {/* PAGE CHILDREN TO GO HERE */}
        </div>
    )
}

export default Page